'use client';

import { useSetAtom } from 'jotai';
import { SyntheticEvent } from 'react';
import { IServiceInfo } from '@sapientpro/sapientpro-data-models';
import styles from './Subservice.module.scss';
import contactModalTriggerButton from '../../store/contactForm';
import useContactExpert from '../../useContactExpert';
import { GAEmit, GAEvents } from '../../gtagHelper';
import Button, { ButtonVariants } from '../../components/Button';

const WorkTogetherButton = ({
  contactFormExpert,
  buttonText,
}: {
  contactFormExpert: IServiceInfo['contactFormExpert'];
  buttonText: string
}) => {
  const setContactsModalTrigger = useSetAtom(contactModalTriggerButton);
  useContactExpert(contactFormExpert);

  const handleWorkTogetherClick = (event: SyntheticEvent) => {
    setContactsModalTrigger(`${(event.target as HTMLElement).innerText} | Lets work together`);
    GAEmit(GAEvents.letsWorkTogetherClick);
  };

  return (
    <Button
      variant={ButtonVariants.OUTLINED}
      className={styles.hero__button}
      icon={(
        <svg>
          <use
            xlinkHref='/media/icon-nest.svg#iconNest'
            href='/media/icon-nest.svg#iconNest'
          />
        </svg>
                    )}
      iconPosition='right'
      iconSize={{ width: 24, height: 24 }}
      onClick={handleWorkTogetherClick}
    >
      {buttonText}
    </Button>
  );
};

export default WorkTogetherButton;
